import Cookies from "js-cookie";
import { signOut } from "next-auth/react";

export const setCookieValue = (key, value, duration) => {
  return Cookies.set(key, value, { expires: duration });
};

export const getCookieValue = (key) => {
  return Cookies.get(key);
};

export const removeCookieValue = (key) => {
  return Cookies.remove(key);
};

export const onUnAuthorizeLogoutHandle = () => {
  var Cookies = document.cookie.split(";");
  for (var i = 0; i < Cookies.length; i++) {
    document.cookie = Cookies[i] + "=;expires=" + new Date(0).toUTCString();
  }
  localStorage.clear();
  window.location.href = "/sign-in";
};

export const formatDate = (dateString, formatType) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = String(date.getFullYear()); // Get the last two digits of the year
  if (formatType === "yy-mm-dd") {
    return `${year}-${month}-${day}`;
  } else {
    return `${day}-${month}-${year}`;
  }
};

export const formatDateInMonthNameDateAndYear = (dateValue) => {
  const date = new Date(dateValue);

  // Convert to the desired format: "Jul 10, 2024"
  const options = { year: "numeric", month: "short", day: "numeric" };
  const formattedDate = date.toLocaleDateString("en-US", options);
  return formattedDate;
};
export const convertToTimeFormat = (timestamp) => {
  console.log(timestamp, "timestamp");
  const now = new Date();
  const targetTime = new Date(timestamp);

  // Calculate the time difference in milliseconds
  const diffMs = Math.abs(now - targetTime);

  // Calculate time units
  const msInMinute = 60 * 1000;
  const msInHour = 60 * msInMinute;
  const msInDay = 24 * msInHour;

  const days = Math.floor(diffMs / msInDay);
  const hours = Math.floor((diffMs % msInDay) / msInHour);
  const minutes = Math.floor((diffMs % msInHour) / msInMinute);

  return `${days}d ${hours}h ${minutes}min`;
};

export function ValidatePhone(phone) {
  const pattern = /^[0-9]+$/;
  return pattern.test(phone);
}
export function NumberCheck(str) {
  const alphabeticRegex = /^[a-zA-Z ]+$/;
  return alphabeticRegex.test(str);
}
export function isAlphanumeric(str) {
  // Regular expression to check if the string contains only letters and numbers
  let regex = /^[A-Z0-9]+$/;
  return regex.test(str);
}
export function isStringPresent(input) {
  let regex = /[^a-zA-Z]/;
  return regex.test(input);
}

export function formatRowIndex(rowIndex) {
  const adjustedIndex = rowIndex + 1;

  return adjustedIndex < 10 ? "0" + adjustedIndex : adjustedIndex.toString();
}

// STRING IN FIRST LATTER UPPERCASE REPLACE DEFINE COMMON FUNCTION
export const firstLetterUppercase = (string = "") => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

// STRING IN TRUNCATE DEFINE COMMON FUNCTION
export const truncateString = (str, num = 3) => {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + "...";
};

/**
 * Format a number to a USD string.
 * @param {number|string} [value=""] - The number to be formatted.
 * @returns {string} The formatted string.
 * @example
 * formatToUSD(1234) // "$1,234.00"
 * formatToUSD(1234567890) // "$1,234,567,890.00"
 * formatToUSD("1234.56") // "$1,234.56"
 * formatToUSD("") // ""
 */
export function formatToUSD(value = "") {
  if (value === "") return "$0.00";

  const formattedValue = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);

  return formattedValue;
}

/**
 * Normalize product data.
 * @param {Object|Array} rawProduct - Raw product data from API.
 * @returns {Array|Object} Normalized product data.
 * @example
 * normalizeProductData({
 *   id: 1,
 *   product_name: "Product 1",
 *   upc: "1234567890",
 *   brand: "Brand 1",
 *   description: "This is a product description",
 *   model_number: "1234567890",
 *   EcomInventory: {
 *     discount_percentage: 10,
 *     maximum_selling_price: 123.45,
 *     selling_price: 111.11,
 *   },
 *   item_left: 10,
 *   ProductImages: [
 *     {
 *       image_url: "/product-1.jpg",
 *       image_alt: "Product 1",
 *     },
 *   ],
 * })
 *
 * // output
 * {
 *   id: 1,
 *   upc: "1234567890",
 *   name: "Product 1",
 *   brand: "Brand 1",
 *   description: "This is a product description",
 *   modelNumber: "1234567890",
 *   discountPercentage: 10,
 *   price: "$123.45",
 *   discountedPrice: "$111.11",
 *   stockLeft: 10,
 *   img: {
 *     imagePath: "/product-1.jpg",
 *     imageAlt: "Product 1",
 *   },
 * }
 */
export function normalizeProductData(rawProduct = {}) {
  const normalize = (product) => {
    const normalizedProduct = {
      isNormalized: true,
      id: product.id,
      upc: product.upc || "No upc available",
      name: product.product_name,
      quantity: product?.EcomUserCart?.quantity || 0,
      brand: product.brand || "No brand available",
      description: product.description || "No description available",
      modelNumber: product.model_number || "No model number available",
      discountPercentage:
        parseInt(
          product?.discountInPercentage || product?.discountPercentage
        ) ||
        parseInt(product.EcomInventory?.discount_percentage) ||
        0,
      price: {
        formattedValue: formatToUSD(product.EcomInventory?.flash_sale == null?(product.EcomInventory?.maximum_selling_price||product?.maximum_selling_price):product.EcomInventory?.selling_price),
        rawValue: parseInt((product.EcomInventory?.flash_sale == null?(product.EcomInventory?.maximum_selling_price||product?.maximum_selling_price):product.EcomInventory?.selling_price), 10) || 0,
      },
      isFlash: product.EcomInventory?.flash_sale,
      discountedPrice: {
        formattedValue: formatToUSD(
          product.EcomInventory?.flash_sale ||
            product.EcomInventory?.selling_price ||
            product?.selling_price
        ),
        rawValue:
          parseInt(
            product.EcomInventory?.flash_sale ||
              product.EcomInventory?.selling_price ||
              product?.selling_price,
            10
          ) || 0,
      },
      stockLeft:
        parseInt(
          product?.in_stock ||
            product?.EcomInventory?.in_stock ||
            product?.item_left,
          10
        ) || null,
      item_left: product?.item_left,
      img: {
        imagePath:
          product?.ProductImages?.length > 0
            ? product.ProductImages[0]?.image_url
            : "",
        imageAlt:
          product?.ProductImages?.length > 0
            ? product.ProductImages[0]?.image_alt ||
              product.ProductImages[0]?.id
            : product.name,
      },
    };
    return normalizedProduct;
  };

  const normalizeProductData = Array.isArray(rawProduct)
    ? rawProduct.map(normalize)
    : normalize(rawProduct);

  return normalizeProductData;
}

export function normalizeAddress(input) {
  // Helper function to normalize a single address object
  const normalizeAddressObject = (address) => {
    const normalizedAddress = {
      id: address?.id || null,
      userId: address?.user_id || null,
      addressType: address?.address_type || "",
      isDefault: address?.is_default || false,
      houseNumber: address?.house_no || "",
      landmark: address?.landmark || "",
      street: address?.street_name || "",
      city: address?.city_name || "",
      stateId: address?.state_id || null,
      countryId: address?.country_id || null,
      zipCode: address?.zip_code || "",
      firstName: address?.first_name || "",
      lastName: address?.last_name || "",
      phone: address?.phone || "",
      createdAt: address?.createdAt || "",
      updatedAt: address?.updatedAt || "",
      deletedAt: address?.deletedAt || address?.deleted_at || null,
    };

    const addressParts = [
      normalizedAddress?.street,
      normalizedAddress?.houseNumber,
      normalizedAddress?.landmark,
      normalizedAddress?.zipCode,
      normalizedAddress?.city,
      // normalizedAddress.stateId,
      // normalizedAddress.countryId,
    ];

    normalizedAddress.fullAddress = addressParts
      .filter((part) => part && part.trim() !== "")
      .join(", ");

    return normalizedAddress;
  };

  return Array.isArray(input)
    ? input.map(normalizeAddressObject)
    : normalizeAddressObject(input);
}

// CREATES A QUERY STRING FROM AN OBJECT WITH VALID KEY-VALUE PAIRS.
export function createQueryString(params) {
  if (params && typeof params === "object" && Object.keys(params).length > 0) {
    const queryString = Object.entries(params)
      .filter(
        ([, value]) => value != null && value !== "" && value !== undefined
      )
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    return queryString ? `?${queryString}` : "";
  }
  return "";
}

// COMMON FUNCTION FOR CHECK NUMBER
export const isNumeric = (str) => {
  const regex = /^(?!0+(\.0+)?$)\d+(\.\d+)?$/;
  return regex.test(str);
};

export function convertToUSD(number) {
  return !isNumeric(number)
    ? ""
    : new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(number);
}
export const removeNextAuthSession = () => {
  signOut({ redirect: false });
};

export const fetchUserIp = async () => {
  try {
    // Use a public API to fetch the user's IP address
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip || 0;
  } catch (error) {
    console.error("Error fetching user IP:", error);
    return 0;
  }
};
